import { styled } from '@mui/material/styles'
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip'

const TourTooltip = styled(({ className, ...props }: TooltipProps) => {
    return <Tooltip {...props} open={true} classes={{ popper: className }} onOpen={() => {
    }} onClose={() => {
    }} />
})(({ theme }) => {
    return {
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: theme.palette.common.white,
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: '300px',
            padding: theme.spacing(0),
            whiteSpace: 'normal',
            overflowWrap: 'break-word'
        }
    }
})

export default TourTooltip